<div class="draggable-item mt-2 mb-2 item-depth--{{depth}}" 
    [ngClass]="{'draggable-item-disabled': item.disabled}">
    
    <div class="row ml-0 mr-0 align-items-center">
        <i class="draggable-icon fa fa-angle-right btn"
           (click)="toggleChildren()"
           [ngClass]="{'fa-angle-down': showChildren, 'invisible': item.children.length < 1}">
        </i>

        <i class="draggable-icon drag-handle fa fa-bars" 
           cdkDragHandle 
           [title]="item.disabled ? 'Item is disabled and cannot be moved' : 'Drag to reorder'"
           [ngClass]="{'text-muted': item.disabled}"></i>
        <div class="col draggable-content">
            <div class="input-group" [ngSwitch]="item.itemConfigType">
                <!--Category =-->
                <ng-container *ngSwitchCase="itemConfigType.CategoryItemConfig">
                    <span class="input-group-addon bg-primary text-white">
                        <small>
                            <strong *ngIf="depth < 1">Category</strong>
                            <strong *ngIf="depth > 0">Section</strong>
                        </small>
                    </span>
                    <input *ngIf="depth < 1" type="text" class="form-control"
                           [(ngModel)]="item.name"
                           [maxlength]="maxlength"
                           (change)="saveItem()"
                           required />
                    <input *ngIf="depth > 0" type="text" class="form-control"
                           [(ngModel)]="item.name"
                           (change)="saveItem()"
                           required />
                </ng-container>

                <!--Html Text =-->
                <ng-container *ngSwitchCase="itemConfigType.HtmlTextItemConfig">
                    <span class="input-group-addon">
                        <small><strong>Text</strong></small>
                    </span>
                    <input type="text" class="form-control"
                           [(ngModel)]="item.name"
                           [maxlength]="maxlength"
                           (change)="saveItem()"
                           required />
                </ng-container>
                <!--Date-->
                <ng-container *ngSwitchCase="itemConfigType.DateItemConfig">
                    <span class="input-group-addon">
                        <small><strong>Date</strong></small>
                    </span>
                    <input type="text" class="form-control"
                           [(ngModel)]="item.name"
                           [maxlength]="maxlength"
                           (change)="saveItem()"
                           required />
                </ng-container>

                <!--Dropdown-->
                <ng-container *ngSwitchCase="itemConfigType.DropdownItemConfig">
                    <span class="input-group-addon">
                        <small><strong>Dropdown</strong></small>
                    </span>
                    <input type="text" class="form-control"
                           [(ngModel)]="item.name"
                           [maxlength]="maxlength"
                           (change)="saveItem()"
                           required />
                    <span class="input-group-addon p-0 bg-white">
                      <ng-select [allowClear]="true"
                                 [items]="dropdownOptions"
                                 (selected)="onDropDownItemSelected($event)"
                                 placeholder="No item selected"
                                 [active]="[selectedDropdownItem]"
                                 class="ng-select auto-width">
                      </ng-select>
                    </span>
                </ng-container>

                <span *ngIf="item.disabled" class="input-group-addon bg-default" container="body" tooltip="This item is disabled. Any children are hidden.">
                    <i class="fa fa-eye-slash"></i>
                </span>


                <span *ngIf="item.itemConfigType == itemConfigType.CategoryItemConfig && depth < 1" class="input-group-addon">
                    <small class="text-muted">{{item.name | countdown:maxlength}} characters remaining</small>
                </span>

            </div>
        </div>
        <div #menu id="menu" class="dropdown" [ngClass]="{'show': showMenu}" placement="bottom right">
            <button class="btn btn-outline-secondary btn-sm" (click)="toggleMenu()">
                Actions
                <i class="fa fa-chevron-down ml-2"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-right" role="menu">
                <li role="menuitem">
                    <a class="dropdown-item"
                       *ngIf="item.itemConfigType == itemConfigType.CategoryItemConfig"
                       (click)="addItem(itemConfigType.CategoryItemConfig)">
                        Create section
                    </a>
                </li>
                <li role="menuitem">
                    <a class="dropdown-item"
                       *ngIf="item.itemConfigType == itemConfigType.CategoryItemConfig"
                       (click)="addItem(itemConfigType.HtmlTextItemConfig)">
                        Create text Item
                    </a>
                </li>
                <li role="menuitem">
                    <a class="dropdown-item"
                       *ngIf="item.itemConfigType == itemConfigType.CategoryItemConfig"
                       (click)="addItem(itemConfigType.DateItemConfig)">
                        Create date Item
                    </a>
                </li>
                <li role="menuitem">
                    <a class="dropdown-item"
                       *ngIf="item.itemConfigType == itemConfigType.CategoryItemConfig"
                       (click)="addItem(itemConfigType.DropdownItemConfig)">
                        Create dropdown
                    </a>

                </li>
                <li class="divider dropdown-divider" *ngIf="item.itemConfigType == itemConfigType.CategoryItemConfig"></li>
                <li *ngIf="!item.id" role="menuitem"><a class="dropdown-item" (click)="deleteItem()">Delete item</a></li>
                <li *ngIf="item.id && item.disabled" role="menuitem"><a class="dropdown-item" (click)="toggleDisableItem()">Enable item</a></li>
                <li *ngIf="item.id && !item.disabled" role="menuitem">
                    <a class="dropdown-item" (click)="toggleDisableItem()">
                        <span *ngIf="item.itemConfigType == itemConfigType.CategoryItemConfig && depth < 1 && item.name">Disable category</span>
                        <span *ngIf="item.itemConfigType == itemConfigType.CategoryItemConfig && depth > 0 && item.name">Disable section</span>
                        <span *ngIf="item.itemConfigType !== itemConfigType.CategoryItemConfig && item.name">Disable item</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="draggable" 
        cdkDropList 
        id="child-drop-list-{{item.id}}"
        [cdkDropListData]="item.children"
        (cdkDropListDropped)="onChildDrop($event)"
        *ngIf="showChildren && item.children && item.children.length > 0">
        <div *ngFor="let childItem of item.children; let i = index"
             cdkDrag
             [cdkDragData]="childItem"
             [cdkDragDisabled]="childItem.disabled"
             class="child-drag-wrapper">
            <itemconfiglistitem [hidden]="childItem.disabled && hideDisableItems"
                                [item]="childItem" [items]="childItem.children"
                                [depth]="depth+1"
                                [hideDisableItems]="hideDisableItems"
                                id="{{childItem.id}}"
                                attr.parentId="{{childItem.parentId}}"
                                (itemDeleted)="onItemDeleted(childItem)"
                                [dropdownOptions]="dropdownOptions"></itemconfiglistitem>
        </div>
    </div>
</div>
